import { create } from 'zustand';
import { IDBScanParameters } from '../db-scan-interfaces';
import { DistanceType } from '../../cluster-interfaces';

interface DBScanState {

    params: IDBScanParameters|null;
    setParams: (_params: IDBScanParameters|null) => void;

    distance: DistanceType;
    setDistance: (_distance: DistanceType) => void;
}

export const useDBScanStore = create<DBScanState>()((set) => ({

    params: null,
    setParams: (_params: IDBScanParameters|null) => {
        return set((state: DBScanState) => {
            return {
                ...state,
                params: _params,
            };
        });
    },

    distance: DistanceType.Manhattan,
    setDistance: (_distance: DistanceType) => {
        return set((state: DBScanState) => {
            return {
                ...state,
                distance: _distance,
            };
        });
    },
}))